export const RotateCameraIcon = () => {
	return (
		<svg viewBox="0 0 256 256">
			{/* <rect fill="none" height="256" width="256" /> */}
			<path
				d="M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z"
				fill="none"
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="16"
			/>
			<path d="M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
			<path d="M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
			<polyline fill="none" points="176 96 172 120 148 124" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
			<polyline fill="none" points="108 140 84 144 80 168" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
		</svg>
	);
};
